import { makeStyles } from '~/UIKit/Style';
import { FONT_SIZE_MEDIUM } from '~/Constants/UI.constants';

export const useStyles = makeStyles(
  (theme) => ({
    container: {
      display: 'flex',
      padding: '8px 0',
      alignItems: 'center',
      justifyContent: 'space-between',
      [theme.breakpoints.up('md')]: {
        padding: '0 2px 13px 8px',
      },
    },
    text: {
      fontSize: FONT_SIZE_MEDIUM,
      fontWeight: 'bold',
      lineHeight: '23px',
      minWidth: 'max-content',
      letterSpacing: 0.5,
    },
    weekMonthNavigation: {
      display: 'flex',
      alignItems: 'center',
    },
    navigationButton: {
      [theme.breakpoints.up('md')]: {
        padding: 0,
      },
    },
  }),
  { name: 'CalendarDatePickerNavigation' },
);
